import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const WarningCircleSolidIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M6.07 2.09a2.222 2.222 0 0 1 3.86 0l5.511 9.53c.865 1.496-.186 3.41-1.93 3.41H2.489c-1.743 0-2.794-1.914-1.93-3.41zm1.21 8.794c0-.398.322-.721.72-.721h.007a.721.721 0 0 1 0 1.442H8a.72.72 0 0 1-.72-.721M8.72 5.837a.721.721 0 1 0-1.442 0v2.884a.72.72 0 1 0 1.442 0z"
      clipRule="evenodd"
    />
  </svg>
);
WarningCircleSolidIcon.id = 'WarningCircleSolidIcon';
WarningCircleSolidIcon.displayName = 'WarningCircleSolidIcon';
export default WarningCircleSolidIcon;
